<template>
    <div id="searchTml">
        <a-row v-if="isHeader">
            <a-row class="pageProperty-btn">
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('generic.Add') }}</span>
                    </template>
                    <img @click="addAdvSearch('add')" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
                </a-tooltip>
                <a-tooltip placement="topLeft" v-if="isPublish">
                    <template slot="title">
                        <span>{{ $t('generic.Publish') }}</span>
                    </template>
                    <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        @click="publishBtnSave"
                        icon="safety-certificate"
                    ></a-button>
                </a-tooltip>
            </a-row>
            <a-row>
                <a-table
                    :dataSource="tmlData"
                    :columns="columns"
                    :pagination="Nopagination"
                    size="small"
                    :locale="tabelText"
                    :loading="loading"
                >
                    <template
                        v-for="(item, index) in scopedSlotsArray"
                        :slot="item"
                        slot-scope="text"
                    >
                        <span :key="index">
                          <a-tooltip placement="topLeft">
                            <template slot="title">
                              <span class="tableFontSize">{{text}}</span>
                            </template>
                            <div class="tableFontSize">{{text}}</div>
                          </a-tooltip>
                        </span>
                   </template>
                    <img slot="operation" slot-scope="text"  @click="addAdvSearch('edit', text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
                </a-table>
            </a-row>
        </a-row>

        <!--Advance search-->
        <a-modal
                :title="$t('generic.AdvanceSearch')"
                v-model="AdvanceSearchVis"
                width="80%"
        >
            <a-row type="flex" justify="start" style="margin-bottom: 10px;">
                <a-col style="margin-right: 5px;"><span>{{ $t('generic.AdvanceSearch') }}: </span></a-col>
                <a-col>
                    <a-select
                        size="small"
                        style="width: 240px"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        v-model="modelTemplateName"
                        @change="searchTmlSelectChange"
                    >
                        <a-select-option :value="item.templateName" v-for="item in tmlData">{{item.templateName}}</a-select-option>
                    </a-select>
                </a-col>
                <a-col style="margin: 0 4px">
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t('generic.Add') }}</span>
                        </template>
                        <img @click="addTmlNameBtn('add')" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
                    </a-tooltip>
                </a-col>
                <a-col>
                    <a-popconfirm
                            :title="$t('generic.AreyoudeleTask')"
                            :okText="$t('generic.Yes')"
                            :cancelText="$t('generic.No')"
                            @confirm="addTmlNameBtn('del')"
                    >
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('generic.Delete') }}</span>
                            </template>
                            <img class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                        </a-tooltip>
                    </a-popconfirm>
                </a-col>
            </a-row>

            <a-row type="flex" justify="start" style="margin-bottom: 4px;">
                <a-col style="margin-right: 5px;"><span>{{ $t('generic.IsDefault') }}: </span></a-col>
                <a-col><a-switch v-model="isDefaultVal" size="small"/></a-col>
            </a-row>

            <a-row>
                <and-or :options="options" :isFirst="isFirst" ref="andOr" :isSearchTml="options.isSearchTml"></and-or>
            </a-row>
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveTml('save')">{{ $t('publicLang.Save') }}</a-button>
            </template>
        </a-modal>




        <!--添加Advance search temalate name-->
        <a-modal :title="$t('generic.Add')" v-model="tmlNameVIis">
            <template slot="footer">
                <a-button size="small" type="primary" @click="submintTmplName">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="adchNameFrom">
                <a-form-item :label="$t('generic.Name')" v-bind="formItemLayout">
                    <a-input
                        v-decorator="[
                              'template',
                              { rules: [{ required: true, message: 'Please input your Name' }] }
                            ]"
                            :placeholder="$t('publicLang.PleaseSelect')"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import andOr from "./queryBuilder/components/AndOR.vue";
     // generic Searchtml  reportSeting 用的search
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";

    import { mapState } from "vuex";
    export default{
        components: {
            andOr,
        },
//        props:['uid','isPublish'],
        props:{
            isPublish:{ // true 是在ReportSting
                type: Boolean,
                default: function() {
                    return  false;
                }
            },
            uid:{ // 表格UID 或 当reprotsing前数据UID
                type: Number,
                default: function() {
                    return  undefined;
                }
            },
            tableID:{ // 表格UID
                type: Number,
                default: function() {
                    return  undefined;
                }
            },
            isHeader:{
                type: Boolean,
                default: function() {
                    return  true;
                }
            }
        },
        watch: {
            //      监听uid是否有值 请求对应tabs数据
            uid(val) {
                if (val != "") {
                    this.tableInit();
                }
            }
        },
        created(){
            this.tableInit()
        },
        computed: {
            columns(){
                return [
                    {
                        title: this.$t('generic.TemplateName'),
                        dataIndex: "templateName",
                        scopedSlots: { customRender: "templateName" }
                    },
                    {
                        title: this.$t('generic.CreateTime'),
                        dataIndex: "createTime",
                        scopedSlots: { customRender: "createTime" }
                    },
                    {
                        title: this.$t('generic.Action'),
                        scopedSlots: { customRender: "operation" }
                    }
                ];
            }
        },
        data(){
            return{
                editsqlUid: undefined, // 编辑信息
//                table
                isDefaultVal: false,
                loading: true,
                scopedSlotsArray: ["templateName", "createTime"],
                Nopagination: false,
                tmlData: [],
                tabelText: {
                    emptyText: "No record found"
                },
//                advanSearch
                AdvanceSearchVis: false,
                options: {
                    // query filter 下拉
                    condition: [],
                    fieldNameSel: [],
                    status: [],
                    isSearchTml: true
                },
                isFirst: true,
                modelTemplateName: undefined,
//                templatNameadd
                tmlNameVIis: false,
                adchNameFrom: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            publishBtnSave(){
                ajax.get(api.GEERICUDRPUBLISH,{uid: this.uid}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                    }
                })
            },
            tableInit(){
                this.loading = true
                if(this.isPublish){
                    ajax.get(api.GENERICUDRTEMPLATELIST,{gmcUid: this.tableID,ugcUid: this.uid}).then(res=>{
                        let data = res.data
                        this.loading = false
                        for(let i in data){
                            data[i].key = i
                        }
                        this.tmlData = data
                    })
                }else{
                    ajax.get(api.GENERIXMODULEALLSQLTML,{gmcUid: this.uid}).then(res=>{
                        let data = res.data
                        this.loading = false
                        for(let i in data){
                            data[i].key = i
                        }
                        this.tmlData = data

                    })
                }
            },
            addAdvSearch(type,text){
//                下拉数据
                this.editsqlUid = undefined
                this.isDefaultVal = false
                this.modelTemplateName = undefined
                this.AdvanceSearchVis = true
//                下拉数据
                let params = {
                    gmcUid: this.uid
                };
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
                if(this.isPublish){
                    let paramsUgc = {
                        gmcUid: this.tableID,
                        ugcUid: this.uid
                    }
                    ajax.get(api.GENERICUDRDROPDOWNFIELNAME,paramsUgc).then(res=>{
                        this.options.fieldNameSel = res.data;
                    })
                }else{
                    ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                        this.options.fieldNameSel = res.data;
                    });
                }

                ajax.get(api.GEBERICMODULESTATUS,params).then(res => {
                    this.options.status = res.data;
                });
//              编辑
                if(type == 'edit'){
                    if(text.default == '1'){
                        this.isDefaultVal = true
                    }
                    let queryObj = JSON.parse(text.condition)
                    this.$nextTick(()=>{
                        this.$refs.andOr.fillFormStatus(queryObj.rules[0])
                    })
                    this.editsqlUid = text
                    this.modelTemplateName = text.templateName
                    return
                }
                this.$nextTick(()=>{
                    this.$refs.andOr.fillFormStatus(undefined)
                })
            },
            addTmlNameBtn(type){
                if(type == 'add'){
                    this.tmlNameVIis = true
                }else{
                    let id = ''
                    for(let i in this.tmlData){
                        if(this.tmlData[i].templateName == this.modelTemplateName){
                            id = this.tmlData[i].uid
                        }
                    }

                    console.log(id);
                    if(this.isPublish){
                        ajax.post(api.GENERICUDRTEMPLATEDELETION,{uids:[id]}).then(res=>{
                            this.modelTemplateName = undefined
                            this.tableInit()
                        })
                    }else{
                        ajax.post(api.MODULEDELETIONSQL,{uids:[id]}).then(res=>{
                            this.modelTemplateName = undefined
                            this.tableInit()
                        })
                    }
                    let obj = {condition: "AND", rules: []}
                    this.$nextTick(()=>{
                        this.$refs.andOr.fillFormStatus(obj)
                    })
                }
            },
            searchTmlSelectChange(val){
                for(let i in this.tmlData){
                    if(this.tmlData[i].templateName == val){
                        if(this.tmlData[i].default == '1'){
                            this.isDefaultVal = true
                        }
                        let queryObj = JSON.parse(this.tmlData[i].condition)
                        this.$nextTick(()=>{
                            this.$refs.andOr.fillFormStatus(queryObj.rules[0])
                        })
                    }
                }

            },
            saveTml(tml){
                if(tml == 'save'){
                    tml = this.modelTemplateName
                }
                if(tml == undefined){
                    this.$customMessage.error('Please Select a TemplateName');
                    return
                }
                let arr = [this.$refs.andOr.queryFormStatus()]

                if(this.isPublish){
                    let params = {
                        generic:1,
                        rules:arr,
                        defaultIs: this.isDefaultVal,
                        template: tml,
                        gmcUid: this.tableID,
                        ugcUid: this.uid,
                    }
                    if(this.editsqlUid != undefined){
                        params.sqlUid = this.editsqlUid.uid
                    }
                    ajax.post(api.GENERICUDRTEMPLATE,params).then(res=>{
                        if(res.code == 200){
                            this.$refs.andOr.fillFormStatus(undefined)
                            this.AdvanceSearchVis = false
                            this.tableInit()
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    })
                }else{
                    arr.gmcUid = this.uid
                    let params = {
                        generic:1,
                        rules:arr,
                        defaultIs: this.isDefaultVal,
                        template: tml,
                        gmcUid: this.uid
                    }
                    ajax.post(api.GENERICMODULESQLTML,params).then(res=>{
                        if(res.code == 200){
                            this.$refs.andOr.fillFormStatus(undefined)
                            this.AdvanceSearchVis = false
                            this.tableInit()
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    })
                }

            },
            submintTmplName(){
                this.adchNameFrom.validateFields((err,value)=>{
                    if(!err){
                        this.saveTml(value.template)
                        this.tmlNameVIis = false
                        this.modelTemplateName = undefined
                        this.adchNameFrom.resetFields();
                    }
                })
            }
        }
    }
</script>
<style lang="less">
    .and-or-top, .btn-and-or{
        margin: 0 !important;
    }
    .form-group{
        margin-top: 17px;
    }
    #searchTml {
        margin-top: 14px;
        .pageProperty-btn {
            margin-bottom: 14px;
            button {
                margin-right: 14px;
            }
        }
    }
</style>